var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_10675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8.02197H10",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.02197V10.022",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66669 4.02196V3.3553C2.66669 3.17848 2.73693 3.00892 2.86195 2.88389C2.98697 2.75887 3.15654 2.68863 3.33335 2.68863H4.00002L2.66669 4.02196ZM7.33335 2.68863H8.66669H7.33335ZM12 2.68863H12.6667C12.8435 2.68863 13.0131 2.75887 13.1381 2.88389C13.2631 3.00892 13.3334 3.17848 13.3334 3.3553V4.02196L12 2.68863ZM13.3334 7.3553V8.68863V7.3553ZM13.3334 12.022V12.6886C13.3334 12.8654 13.2631 13.035 13.1381 13.16C13.0131 13.2851 12.8435 13.3553 12.6667 13.3553H12L13.3334 12.022ZM8.66669 13.3553H7.33335H8.66669ZM4.00002 13.3553H3.33335C3.15654 13.3553 2.98697 13.2851 2.86195 13.16C2.73693 13.035 2.66669 12.8654 2.66669 12.6886V12.022L4.00002 13.3553ZM2.66669 8.68863V7.3553V8.68863Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_10675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0219727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/createIcon.fd1caec9109f13db1c8729febcf47f68.svg";
export { ForwardRef as ReactComponent };